export default __webpack_public_path__ + "static/media/white-layers-icon.75675344.svg";